import {FETCH_COUNTRY_LIST} from '../actionTypes';

const countryReducer = (state = [], action) => {
    switch (action.type) {
        case FETCH_COUNTRY_LIST:
            return action.payload;
        default:
            return state;
    }
};

export default countryReducer;